var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: "standard-navigation__bullet-custom-icon ".concat(_vm.iconClass),
    attrs: {
      "aria-hidden": "true"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }